import { Box, Switch, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import Footer from "../../SharePages/Footer/Footer";
import FooterLR from "../FooterLR/FooterLR";
import Navbar from "../Navbar/Navbar";

const PrivacyPolicy = () => {
  window.scrollTo(0, 0);
  const [isChecked, setIsChecked] = useState(false);
  const handleChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <>
      <Navbar></Navbar>
      <div className="container my-5 pb-5">
        <div className="row text-justify">
          {/* <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2 align-items-center">
              <p className="fw-bold">English</p>
              <Switch
                size="md"
                className="py-0 mb-0"
                isChecked={isChecked}
                onChange={handleChange}
              />
              <p className="fw-bold">বাংলা</p>
            </div>
          </div> */}
          {!isChecked ? (
            <>
              <div className="col-lg-12">
                <Text fontWeight={700} fontSize="20px" pb={"10px"}>
                  Privacy Policy
                </Text>
              </div>

              <Box>
                <Text pb={"20px"}>
                  Your trust is important to Travelchamp, and we want you to
                  realize how we gather, manage, and share information. This
                  privacy statement explains how we recognize the data we
                  receive from you when you visit our websites, use any mobile
                  applications we make available ("Apps"), or purchase or engage
                  in any of the services we make available through our various
                  channels.
                </Text>

                <Text pb={"20px"}>
                  In order to make reservations and booking the services for the
                  customer/traveler, the name, address, phone number, credit and
                  debit card number and related information, passport number,
                  social media ID links and age of the traveler are provided
                  with the appropriate service providers, such as the airlines.
                  In addition, for service quality, website updates and other
                  information, as well as marketing and promotional purposes, we
                  will connect with you, either ourselves or using one of our
                  associates. You can still explore the Travelchamp website
                  without providing this information, but you might not be able
                  to avail of all the options, promotions, and facilities. We
                  might also disclose your personal information if it's
                  necessary to follow the law or any legal request for
                  information, or if it's necessary to defend our rights.
                </Text>

                <Text pb={"20px"}>
                  The other advertisers and websites are not subject to our
                  privacy policy. For additional in-depth information, we
                  therefore suggest you review the individual privacy policies
                  of these third-party ad servers. Their procedures and
                  guidelines on how to decline particular choices might be
                  included. Cookies can be turned off using the tools available
                  in each browser. You can visit the websites of each web
                  browser in question to learn more in-depth details on managing
                  cookies with that particular browser.
                </Text>

                <Text pb={"20px"}>
                  To keep your personal information secured within our business,
                  we try to apply appropriate organizational, technical, and
                  operational measures. Please let us know instantly if you have
                  any evidence to suggest that interactions with us are no
                  longer secure, for instance, if you suspect the security of
                  your account has been exploited.
                </Text>
              </Box>
            </>
          ) : (
            <>
              <div className="col-lg-12">
                <Text fontWeight={700} fontSize="20px" pb={"10px"}>
                  গোপনীয়তার নীতি
                </Text>
              </div>

              <Box>
                <Text pb={"20px"}>
                  আপনার আস্থা ট্রাভেল চ্যাম্প লিমিটেড জন্য গুরুত্বপূর্ণ এবং আমরা
                  কীভাবে তথ্য সংগ্রহ, পরিচালনা এবং শেয়ার করি তা আমরা আপনাকে অবগত
                  করতে চাই । যখন আপনি আমাদের ওয়েবসাইট ভিজিট করেন, আমাদের তৈরিকৃত
                  মোবাইল এপ্লিকেশন ব্যবহার করেন কিংবা আমাদের যেকোন সার্ভিস গ্রহণ
                  করেন তখন সেখান থেকে আমরা যেভাবে আপনার তথ্য সংগ্রহ করি তা এই
                  গোপনীয়তার নীতি ব্যাখ্যা করে।
                </Text>

                <Text pb={"20px"}>
                  গ্রাহক/ভ্রমণকারীর রিজার্ভেশন এবং বুকিং করার জন্য, নাম, ঠিকানা,
                  ফোন নম্বর, ক্রেডিট এবং ডেবিট কার্ড নম্বর এবং সম্পর্কিত তথ্য,
                  পাসপোর্ট নম্বর, সোশ্যাল মিডিয়া আইডি লিঙ্ক এবং ভ্রমণকারীর বয়স
                  উপযুক্ত পরিসেবা প্রদানকারীকে প্রদান করা হয়, যেমন: এয়ারলাইনস।
                  এছাড়াও, পরিসেবার গুণমান, ওয়েবসাইট আপডেট এবং অন্যান্য তথ্যের
                  জন্য এবং প্রচারমূলক উদ্দেশ্যে, আমরা নিজেরা বা আমাদের প্রতিনিধি
                  আপনার সাথে যোগাযোগ করবে । আপনি এই তথ্য প্রদান না করেও
                  ফার্স্টট্রিপ ওয়েবসাইট ভিজিট করতে পারেন, তবে সেক্ষেত্রে আপনি
                  সমস্ত বিকল্প, প্রচার এবং সুবিধাগুলি না ও পেতে পারেন৷ আইন মেনে
                  চলার প্রয়োজন হলে বা তথ্যের জন্য কোনো আইনি অনুরোধ বা আমাদের
                  অধিকার রক্ষার প্রয়োজন হলে আমরা আপনার ব্যক্তিগত তথ্যও প্রকাশ
                  করতে পারি।
                </Text>

                <Text pb={"20px"}>
                  অন্যান্য বিজ্ঞাপনদাতা এবং ওয়েবসাইটগুলি আমাদের গোপনীয়তা নীতির
                  অধীন নয়৷ অতিরিক্ত তথ্যের জন্য, তাই আমরা আপনাকে এই তৃতীয়
                  পক্ষের বিজ্ঞাপন সার্ভারগুলির পৃথক গোপনীয়তা নীতিগুলি
                  পর্যালোচনা করার পরামর্শ দিয়ে থাকি৷ তাদের পদ্ধতি এবং নির্দিষ্ট
                  নীতিমালা সেখানে অন্তর্ভুক্ত করা থাকতে পারে। প্রতিটি ব্রাউজারের
                  জন্য ব্যবহারযোগ্য সরঞ্জাম ব্যবহার করে কুকিজ বন্ধ করা যেতে
                  পারে। আপনি সেই নির্দিষ্ট ব্রাউজারের সাথে কুকিজ পরিচালনার
                  বিষয়ে আরও বিস্তারিতভাবে জানতে প্রতিটি ওয়েব ব্রাউজারের
                  ওয়েবসাইটগুলি দেখতে পারেন।
                </Text>

                <Text pb={"20px"}>
                  আমাদের ব্যবসার সাথে আপনার ব্যক্তিগত তথ্য সুরক্ষিত রাখতে, আমরা
                  উপযুক্ত সাংগঠনিক, প্রযুক্তিগত এবং অপারেশনাল ব্যবস্থা প্রয়োগ
                  করার চেষ্টা করি। যদি আপনার কাছে আমাদের দেওয়ার মত কোন প্রমান
                  থাকে যে আমাদের সাথে আপনার যোগাযোগ নিরাপদ নয় সেক্ষেত্রে
                  তৎক্ষনাৎ আমাদেরকে জানান; উদাহরণস্বরূপ যদি আপনি সন্দেহ করেন যে
                  আপনার অ্যাকাউন্টের নিরাপত্তা ঝুঁকিতে রয়েছে।
                </Text>
              </Box>
            </>
          )}
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default PrivacyPolicy;
